module.exports = __webpack_public_path__ + "static/media/campaignSkeletonXl.03213000.svg";